import React, { Component } from 'react';
import Collapsible from 'react-collapsible';
import documents from "../images/documents.png";
import { BOOK_SECTIONS } from "../../utils/const";
import BooksList from "../educationWorkPrograms/BooksTable/BooksList";
import styles from './Umk.module.css'

const listFirst = [
    { name: 'Выписка из ФГОС', url: 'fgos' },
    { name: 'Выписка из квалифицированных требований', url: 'kt' },
    { name: 'Учебный план', url: 'edu_plan' }
];

const listSecond = [
    { name: 'Рабочая учебная программа', url: 'work_program' },
    { name: 'Тематический план', url: 'tema_plan' },
    { name: 'Основные образовательные ресурсы', id: 1 },
    { name: 'Дополнительные образовательные ресурсы', id: 2 }
];

const listThird = [
    { name: 'Фонд контрольных заданий', id: 6 },
    { name: 'Методические рекомендации для преподавателей', id: 3 },
    { name: 'Методические указания для обучающихся', id: 4 },
    { name: 'Учебно-методическая документация', id: 5 }
];

class UmkCard extends Component {

    state = {
        isActive: '',
        idActive: false,
        location: false,
        oid: null,
        files: [],
        title: '',
        tlid: null,
        isOpen: false,
    };

    componentDidMount() {
        const { fetchUmkCard, location, umkCard } = this.props;
        fetchUmkCard(location.state.id);
        if (umkCard && umkCard.id_curriculum_course) {
            this.fetchCoursebooks(umkCard.id_curriculum_course.split(', ').map(id => parseInt(id)));
        };
    };

    componentWillUnmount() {
        this.props.resetCourseBooks();
    }


    fetchCoursebooks = (ids) => {
        ids.map(id => {
            this.props.fetchCourseBooks(id);
        })
    }

    onCLickList = async (name, id) => {
        if (id !== '') {
            await this.setState({
                isActive: name,
                idActive: id,
                isOpen: false
            });
            id !== 'fgos' && id !== 'kt' && this.props.fetchListData(this.props.umkCard.id, this.state.idActive)
        }
    };

    renderList = (list) => (
        <div className="umkT-list-div">
            {list.map((el, index) => (
                <div
                    className={this.state.isActive === el.name ? "umkT-list-child-active" : "umkT-list-child"}
                    key={index}
                    onClick={() => this.onCLickList(el.name, el.id || el.url)}
                >
                    <span className="umkT-list-span">{el.name}</span>
                </div>
            ))
            }
        </div>
    );

    renderUmkListData = (umk) => {
        return umk.map((el, index) => (
            <div key={index}>
                <a href={el.link}>{el.description}</a>
            </div>
        ))
    };

    goBack = () => {
        this.props.history.push({ pathname: `/umkTeacher/`, state: this.props.history.location.state.params })
    };

    componentWillUnmount() {
        this.props.clearUmkData();
    };

    renderUmkDisciplines = (data) => {
        return Object.values(data).map((el, index) => {
            return el.subjects.length > 0 &&
                <div className='tableContent'>

                    <Collapsible
                        key={index}
                        classParentString="cemests"
                        trigger={el.name}
                    >
                        <table className="tableSemestr">
                            <thead>
                                <tr>
                                    <th className="table-title">Наименование</th>
                                    <th className="table-title">Л</th>
                                    <th className="table-title">С</th>
                                    <th className="table-title">ЛР</th>
                                    <th className="table-title">П</th>
                                    <th className="table-title">ГУ</th>
                                    <th className="table-title">ГЗ</th>
                                    <th className="table-title">ТЗ</th>
                                    <th className="table-title">ВИ</th>
                                    <th className="table-title">КУР</th>
                                    <th className="table-title">СРП</th>
                                    <th className="table-title">З</th>
                                    <th className="table-title">СР</th>
                                    <th className="table-title">КР</th>
                                    <th className="table-title">Ф</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.renderDiscipline(el.subjects)}
                            </tbody>
                        </table>
                    </Collapsible>
                </div>
        })
    };

    renderDiscipline = (data) => {
        return data.map((el, index) => (
            <tr key={index}>
                <td>{el.title}</td>
                <td>{el.lecturing}</td>
                <td>{el.seminar}</td>
                <td>{el.laboratory_works}</td>
                <td>{el.practical_training}</td>
                <td>{el.group_exercises}</td>
                <td>{el.group_classes}</td>
                <td>{el.tactical_exercises}</td>
                <td>{el.war_games}</td>
                <td>{el.course_work}</td>
                <td>{el.ind_with_lecturer}</td>
                <td>{el.test}</td>
                <td>{el.independent_work}</td>
                <td>{el.control_work}</td>
                <td>
                    {el.files && (
                        <img
                            src={documents}
                            alt=""
                        />
                    )}
                </td>
            </tr>
        ))
    };

    renderTable = (umk) => {
        try {
            return umk.map((el, index) => (
                <tr key={index} className="umkEduPlan">
                    <td>{` `}</td>
                    <td>{el.idx}</td>
                    <td>{el.discipline}</td>
                    <td>{el.labour_intensity}</td>
                    <td>{el.hrs}</td>
                    <td>{el.with_lecturer}</td>
                    <td>{el.lecturing}</td>
                    <td>{el.seminar}</td>
                    <td>{el.laboratory_works}</td>
                    <td>{el.practical_training}</td>
                    <td>{el.group_execises}</td>
                    <td>{el.group_classes}</td>
                    <td>{el.tactical_execises}</td>
                    <td>{el.war_games}</td>
                    <td>{el.control_work}</td>
                    <td>{el.course_work}</td>
                    <td>{el.ind_with_lecturer}</td>
                    <td>{el.test}</td>
                    <td>{el.independent_work}</td>
                    <td>{el.s1}</td>
                    <td>{el.i1}</td>
                    <td>{el.s2}</td>
                    <td>{el.i2}</td>
                    <td>{el.s3}</td>
                    <td>{el.i3}</td>
                    <td>{el.s4}</td>
                    <td>{el.i4}</td>
                    <td>{el.s5}</td>
                    <td>{el.i5}</td>
                    <td>{el.s6}</td>
                    <td>{el.i6}</td>
                    <td>{el.s7}</td>
                    <td>{el.i7}</td>
                    <td>{el.s8}</td>
                    <td>{el.i8}</td>
                    <td>{el.s9}</td>
                    <td>{el.i9}</td>
                    <td>{el.s10}</td>
                    <td>{el.i10}</td>
                    <td>{el.fin_exam}</td>
                    <td>{el.fin_test}</td>
                    <td>{el.fin_test_with_grade}</td>
                    <td>{el.fin_test_work_str}</td>
                </tr>
            ))
        } catch (e) {
            console.log(e)
        }
    };

    renderTemaPlan = (data) => {
        return Object.values(data).map((el, index) => {
            return el.subjects.length > 0 &&
                <div key={index}>
                    <table>
                        <thead>
                            <tr>
                                <td colSpan="4" className="umkTemaHeader">{`${el.name}`}</td>
                            </tr>
                        </thead>
                    </table>
                    {this.renderTemaHeaderList(el.subjects)}
                </div>
        })
    };

    renderTemaHeaderList = (data) => {
        return data.map((el, index) => (
            <table className="umkTemaContainer" key={index}>
                <thead>
                    <tr>
                        <td colSpan="2" className="umkTemaContentHeader">{index + 1}</td>
                        <td className="umkTemaContentHeader">{el.hours}</td>
                        <td className="umkTemaContentHeader">{el.tema}</td>
                    </tr>
                </thead>
                <tbody>
                    {this.renderTemaList(el.details)}
                </tbody>
            </table>
        ))
    };

    renderTemaList = (data) => {
        return data.map((el, index) => (
            <tr key={index} className="umkTemaFirstContentContainer">
                <td className="umkTemaFirstContent">{``}</td>
                <td>{el.lesson_type_desc}</td>
                <td>{el.hours}</td>
                <td>{`Тема лекции: ${el.tema || ''}`}</td>
            </tr>
        ))
    };

    filteredBooks(bookData, filterByPart) {
        return {
            name: BOOK_SECTIONS.find(el => el.id === filterByPart).name,
            list: bookData.filter(el => el.part === filterByPart)
        };
    }

    render() {
        const { umkCard, umkContentData, umkTypeData, books } = this.props;

        const { idActive } = this.state;
        return (
            <div className="umkT">
                <p className="captions">Электронные учебно-методические комплексы дисциплин</p>
                <button className="btn mb-3" onClick={this.goBack}>Назад</button>
                <div className="umkT-info-block">
                    <div>
                        <span>Факультет:</span>
                        <span>{umkCard['Факультет']}</span>
                    </div>
                    <div>
                        <span>Специальность:</span>
                        <span>{umkCard['Военная специальность']}</span>
                    </div>
                    <div>
                        <span>Специализация:</span>
                        <span>{umkCard['Специализация']}</span>
                    </div>
                    <div>
                        <span>Курсы:</span>
                        <span>{umkCard['Курсы']}</span>
                    </div>
                    <div>
                        <span>Группы:</span>
                        <span>{umkCard['Группы']}</span>
                    </div>
                </div>
                {this.renderList(listFirst)}
                {this.renderList(listSecond)}
                {this.renderList(listThird)}
                <div className="emkContent">
                    {idActive === 'fgos' &&
                        <div>
                            <span className='umk-whitespace'>
                                {umkCard['Выписка из ФГОС']}
                            </span>
                        </div>
                    }
                    {idActive === 'kt' &&
                        <div>
                            <span className='umk-whitespace'>
                                {umkCard['Выписка из КТ']}
                            </span>
                        </div>
                    }
                    {idActive === 1 && books.length > 0 ?
                        <BooksList
                            item={this.filteredBooks(books, 1)}
                            booksInfo={null}
                        />
                        : null
                    }
                    {idActive === 2 && books.length > 0 ?
                        <BooksList
                            item={this.filteredBooks(books, 2)}
                            booksInfo={null}
                        />
                        : null
                    }
                    {idActive === 3 && books.length > 0 ?
                        <BooksList
                            item={this.filteredBooks(books, 3)}
                            booksInfo={null}
                        />
                        : null
                    }
                    {idActive === 4 && books.length > 0 ?
                        <BooksList
                            item={this.filteredBooks(books, 4)}
                            booksInfo={null}
                        />
                        : null
                    }
                    {umkContentData.UMKLinks && idActive !== 'fgos' && idActive !== 'kt' && this.renderUmkListData(umkContentData.UMKLinks)}
                    {umkTypeData === 'edu_plan' && umkContentData.UMKEduPlan && idActive !== 'fgos' && idActive !== 'kt'
                        &&
                        (<table>
                            <thead>
                                <tr>
                                    <td rowSpan="3" colSpan="3">{``}</td>
                                    <td colSpan="2" rowSpan="3">Трудоемкость ООП</td>
                                    <td rowSpan="3">{``}</td>
                                    <td colSpan="12" rowSpan="3">Распределение учебного времени по видам учебных занятий</td>
                                    <td rowSpan="3">{``}</td>
                                    <td colSpan="20">Распределение учебного времени по курсам и семестрам</td>
                                    <td colSpan="4">Формы итогового контроля</td>
                                </tr>
                                <tr>
                                    <td colSpan="4">1 курс</td>
                                    <td colSpan="4">2 курс</td>
                                    <td colSpan="4">3 курс</td>
                                    <td colSpan="4">4 курс</td>
                                    <td colSpan="4">5 курс</td>
                                    <td rowSpan="2">Экзамены</td>
                                    <td colSpan="3" rowSpan="2">Зачеты</td>
                                </tr>
                                <tr>
                                    <td colSpan="2">1 семестр</td>
                                    <td colSpan="2">2 семестр</td>
                                    <td colSpan="2">3 семестр</td>
                                    <td colSpan="2">4 семестр</td>
                                    <td colSpan="2">5 семестр</td>
                                    <td colSpan="2">6 семестр</td>
                                    <td colSpan="2">7 семестр</td>
                                    <td colSpan="2">8 семестр</td>
                                    <td colSpan="2">9 семестр</td>
                                    <td colSpan="2">10 семестр</td>
                                </tr>
                                <tr>
                                    <td>№ пп</td>
                                    <td>Индекс</td>
                                    <td>Дисциплина (группа, цикл)</td>
                                    <td>Зачетн. един.</td>
                                    <td>Всего часов уч. занятий</td>
                                    <td>Часы с препод.</td>
                                    <td>Лекции</td>
                                    <td>Семинары</td>
                                    <td>Лабораторные</td>
                                    <td>Практические</td>
                                    <td>Групп. упражн.</td>
                                    <td>Групп. занятия</td>
                                    <td>Тактич. занятия</td>
                                    <td>Военные игры</td>
                                    <td>Контр. работы</td>
                                    <td>Курс. работы</td>
                                    <td>Самост.раб с преподават.</td>
                                    <td>Экзамены, зачёты</td>
                                    <td>Самост. работа</td>
                                    <td>Часы</td>
                                    <td>Зачетн. един.</td>
                                    <td>Часы</td>
                                    <td>Зачетн. един.</td>
                                    <td>Часы</td>
                                    <td>Зачетн. един.</td>
                                    <td>Часы</td>
                                    <td>Зачетн. един.</td>
                                    <td>Часы</td>
                                    <td>Зачетн. един.</td>
                                    <td>Часы</td>
                                    <td>Зачетн. един.</td>
                                    <td>Часы</td>
                                    <td>Зачетн. един.</td>
                                    <td>Часы</td>
                                    <td>Зачетн. един.</td>
                                    <td>Часы</td>
                                    <td>Зачетн. един.</td>
                                    <td>Часы</td>
                                    <td>Зачетн. един.</td>
                                    <td>{`  `}</td>
                                    <td>без оценки</td>
                                    <td>с оценкой</td>
                                    <td>по курс. работам</td>
                                </tr>
                            </thead>
                            <tbody>
                                {this.renderTable(umkContentData.UMKEduPlan)}
                            </tbody>
                        </table>)
                    }
                    {umkTypeData === 'work_program' && umkContentData && idActive !== 'fgos' && idActive !== 'kt'
                        && this.renderUmkDisciplines(umkContentData)
                    }
                    {umkTypeData === 'tema_plan' && umkContentData && idActive !== 'fgos' && idActive !== 'kt'
                        &&
                        <div>
                            <table>
                                <tbody>
                                    <tr className="umkPlan">
                                        <td>№ п/п</td>
                                        <td>Виды учебных занятий</td>
                                        <td>Кол-во часов</td>
                                        <td>Тема и учебные вопросы занятия</td>
                                    </tr>
                                </tbody>
                            </table>
                            {this.renderTemaPlan(umkContentData)}
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default UmkCard;
